import React from "react";
import { Button, Col, Form, Modal, Row, Typography } from "antd";
import { useSearchParams } from "react-router-dom";
import InfoAvatar from "./component/info_avatar";
import FormInput from "component/form/form_input";
import useActionAccount from "hook/bailiff/job/action/useActionAccount";
import TriggerAccountInfo from "./trigger/trigger_account_info";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DialogAccountInfo = () => {
  // -------------------------- VAR -----------------------------
  const [form] = Form?.useForm();
  const { loading, handleClose, handleUpdateAccountInfo } = useActionAccount();
  const [searchParams] = useSearchParams();
  const viewOpenAccount = searchParams.get("viewOpenAccount") || "false";
  const openAccount = viewOpenAccount === "true";

  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const open = openAccount;
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Modal
      onCancel={() => handleClose(form)}
      open={open}
      footer={null}
      title={null}
    >
      <div className="min-h-[400px] p-[32px]">
        <Form form={form} id="dialog-update-name" layout="vertical">
          <Row gutter={[16, 24]}>
            <Col align="center" xl={24} lg={24} md={24} xs={24}>
              <Typography.Title level={3}>
                Cập nhật thông tin tài khoản
              </Typography.Title>
            </Col>
            <Col align="center" xl={24} lg={24} md={24} xs={24}>
              <InfoAvatar />
            </Col>
            <Col xl={24} lg={24} md={24} xs={24}>
              <FormInput
                name="displayName"
                label="Họ và Tên hiển thị"
                className="min-h-[48px] border-[0.5px]"
                placeholder="Nhập tên mà bạn muốn hiển thị trên hệ thống"
                rules={[{ required: true }]}
              />
              <p className="text-[12px] italic text-gray-600">
                Tên thường dùng mà bạn muốn gọi để dễ dàng liên lạc hơn trong
                nền tảng "Dịch Vụ Chuyển Âm"
              </p>
            </Col>

            <Col xl={24} lg={24} md={24} xs={24}>
              <Button
                loading={loading}
                onClick={() => handleUpdateAccountInfo(form)}
                block
                className="min-h-[48px]"
                type="primary"
              >
                Lưu
              </Button>
            </Col>
          </Row>
          <TriggerAccountInfo />
        </Form>
      </div>
    </Modal>
  );
};
export default DialogAccountInfo;
